
import { Vue, Component, Prop } from "vue-property-decorator";

import ResizeAuto from "@/components/common/resize-auto.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import { FileSizeRestrictions } from "@/entities/FileSizeRestrictions";

@Component({
  components: {
    ResizeAuto,
    FormTextarea,
  },
})
export default class InboxWindowTextarea extends Vue {
  @Prop({ type: String, default: undefined })
  readonly predefinedMessage?: string;
  @Prop({ type: Boolean, default: false }) readonly noParticipants!: boolean;
  input: string = "";
  attachment: any | null = null;

  upload() {
    (this.$refs.attachment as Vue & { click: () => boolean }).click();
  }

  mounted() {
    if (this.predefinedMessage) {
      this.input = this.predefinedMessage;
      const message = this.$refs.message as Vue;
      (message.$el as HTMLElement).focus();
    }
  }

  get textareaDisabled(): boolean {
    return this.noParticipants;
  }

  enter(e: any) {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      this.submit();
    }
  }

  submit() {
    if (!(this.input.length || this.attachment)) {
      return;
    }
    const messageText = this.input.replace(/\n/g, "<br />");
    this.$emit("newMessage", {
      content: messageText,
      attachment: this.attachment,
    });
    const message = this.$refs.message as Vue;

    (message.$el as HTMLElement).style.height = "auto";
    this.input = "";
    this.attachment = null;
  }

  newAttachment(event: any) {
    const filesize = parseFloat(
      (event.target.files[0].size / 1024 / 1024).toFixed(4)
    ); // MB

    if (filesize <= FileSizeRestrictions.INBOX_ATTACHMENT_MAX) {
      this.attachment = event.target.files[0];
      return;
    }

    this.$eventBus.emit(
      NOTIFICATION,
      Message.errorMessage(
        `A file, larger than ${FileSizeRestrictions.INBOX_ATTACHMENT_MAX}MB, cannot be attached`
      )
    );
    this.attachment = null;
  }

  removeAttachment() {
    this.attachment = null;
  }
}
